var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.535C12.0463 10.535 13.705 8.87622 13.705 6.83C13.705 4.78379 12.0463 3.125 10 3.125C7.95383 3.125 6.29504 4.78379 6.29504 6.83C6.29504 8.87622 7.95383 10.535 10 10.535Z",
    stroke: "#27272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.34 16.8752C16.34 15.1937 15.6721 13.5811 14.4831 12.3921C13.2941 11.2031 11.6815 10.5352 10 10.5352C8.31856 10.5352 6.70596 11.2031 5.51698 12.3921C4.328 13.5811 3.66003 15.1937 3.66003 16.8752",
    stroke: "#27272A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.233b4d1211e1823b1a94ff9d9095a170.svg";
export { ForwardRef as ReactComponent };